import { Button } from '@material-tailwind/react';
import React from 'react';

export const LiveBanner: React.FC<{
  isLiveEvent: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ isLiveEvent, setOpenDialog }) => {
  return (
    <>
      <div className="grid justify-items-center">
        <div className="w-10/12 bg-primary rounded">
          <div className="grid gap-3 mt-10 mb-10 text-secondary justify-items-center">
            <div>
              <h3 className="text-3xl font-bold">Join us live!</h3>
            </div>
            <div className="w-full md:w-8/12">
              <p className="p-2">
                Businesses are experiencing rising power intermittency and energy costs that
                critically affect their day-to-day operations. Unplanned downtime, huge power
                generation bills, and costly equipment damage lead to high operating expenses and
                businesses shutting down almost daily. Join us at our webinar on the 24th May, 2024
                at 10 am to learn more about Pai Version 1.0 and reducing energy costs, which helps
                reduce operational expenses.
              </p>
            </div>
            <div>
              {isLiveEvent ? (
                <>
                  <Button
                    variant="text"
                    className="flex items-center bg-secondary text-primary gap-2 "
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                    onClick={() => setOpenDialog(true)}
                  >
                    Register{' '}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="h-5 w-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="text"
                    className="flex items-center bg-secondary text-primary gap-2 "
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                    onClick={() => setOpenDialog(true)}
                  >
                    Request video
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="h-5 w-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
